import { disconnectConnectedAccountService, getConnectedAccountsService, setPasswordService } from 'Services'
import { useState } from 'react'

export default function useAccountSecurity () {
  const [loadingAccountSecurityHook, setLoadingAccountSecurityHook] = useState(false)
  const [connectedAccountsHook, setConnectedAccountsHook] = useState({ has_password: true, connected_accounts: [] })

  const getConnectedAccountsHook = async () => {
    try {
      setLoadingAccountSecurityHook(true)
      const res = await getConnectedAccountsService()

      setConnectedAccountsHook(res.data)

      return {
        success: true,
        data: res.data
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while retrieving your connected accounts. Please try again later.'
      }
    } finally {
      setLoadingAccountSecurityHook(false)
    }
  }

  const disconnectConnectedAccountHook = async ({ provider }) => {
    try {
      setLoadingAccountSecurityHook(true)
      await disconnectConnectedAccountService({ provider })

      return {
        success: true
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || `An error occurred while disconnecting your ${provider} account. Please try again later.`
      }
    } finally {
      setLoadingAccountSecurityHook(false)
    }
  }

  const setPasswordHook = async ({ password }) => {
    try {
      setLoadingAccountSecurityHook(true)
      await setPasswordService({ password })

      return {
        success: true
      }
    } catch (e) {
      return {
        success: false,
        message: e?.response?.data?.message || 'An error occurred while setting your password. Please try again later.'
      }
    } finally {
      setLoadingAccountSecurityHook(false)
    }
  }

  return {
    loadingAccountSecurityHook,
    connectedAccountsHook,
    getConnectedAccountsHook,
    disconnectConnectedAccountHook,
    setPasswordHook
  }
}
